import { useEffect } from "react";
import { useMap } from "react-leaflet";
import type { LatLngBoundsExpression } from "leaflet";

/**
 * Imperatively pans/zooms the map to `bounds` — react-leaflet has no
 * declarative prop for this (`MapContainer`'s own `bounds` only applies
 * once, at mount), so it has to go through `useMap()` from a component
 * rendered INSIDE `MapContainer`. Used by SubBasinMap.tsx's sub-basin
 * search (TopBar.tsx/SubBasinSearch.tsx): picking a match sets
 * `highlightedSubBasinCode`, which this reacts to. `LatLngBoundsExpression`
 * (not the `LatLngBounds` class) to accept gisLayer.ts's own plain
 * `[[minLat,minLng],[maxLat,maxLng]]` tuple as-is, same as `MapContainer`'s
 * own `bounds` prop (SubBasinMap.tsx) already does. `maxZoom` keeps a tiny
 * sub-basin from zooming in absurdly close — well under every basemap's
 * own maxZoom (17-20, basemap.ts), so it never asks for tiles that don't
 * exist at that zoom.
 */
export function PanToSubBasin({ bounds }: { bounds: LatLngBoundsExpression | null }) {
  const map = useMap();
  useEffect(() => {
    if (bounds) map.flyToBounds(bounds, { maxZoom: 15, duration: 0.5 });
  }, [map, bounds]);
  return null;
}
